module.exports = __webpack_public_path__ + "static/media/multi-header.d45fc34c.png";